import React from 'react';
import {FormProps} from '../../@types/components/Form';
import Form from '../Form/Form';
import NestedFormRenderer from './NestedFormRenderer';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

export default function NestedForm<Model extends IEmptyModel = IEmptyModel>(props: FormProps<Model>) {
    return <Form<Model>
            {...props}
            formRendererComponent={NestedFormRenderer}
            skipFormComponent={true}
    />;
}
